import { render, staticRenderFns } from "./ReinitialisationMotDePasse.vue?vue&type=template&id=65d82876&scoped=true&"
import script from "./ReinitialisationMotDePasse.vue?vue&type=script&lang=js&"
export * from "./ReinitialisationMotDePasse.vue?vue&type=script&lang=js&"
import style0 from "./ReinitialisationMotDePasse.vue?vue&type=style&index=0&id=65d82876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d82876",
  null
  
)

export default component.exports